import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Prisma",
  "description": "Learn how to use Prisma in a Turborepo."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Prisma unlocks a new level of developer experience when working with databases thanks to its intuitive data model, automated migrations, type-safety & auto-completion."
  }, {
    "heading": "",
    "content": "Their official guide describes how to integrate Prisma into a Turborepo, including:"
  }, {
    "heading": "",
    "content": "Prisma client initialization"
  }, {
    "heading": "",
    "content": "Packaging the client as an Internal Package"
  }, {
    "heading": "",
    "content": "Performing migrations"
  }, {
    "heading": "",
    "content": "Working on your applications locally"
  }, {
    "heading": "",
    "content": "Deploying"
  }, {
    "heading": "example",
    "content": "To get started with our community-supported Prisma example, run:"
  }],
  "headings": [{
    "id": "example",
    "content": "Example"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {Steps, Step} from '#components/steps';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#example",
  title: _jsx(_Fragment, {
    children: "Example"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.prisma.io/",
        children: "Prisma"
      }), " unlocks a new level of developer experience when working with databases thanks to its intuitive data model, automated migrations, type-safety & auto-completion."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.prisma.io/docs/guides/using-prisma-orm-with-turborepo#1-create-your-monorepo-using-turborepo",
        children: "Their official guide"
      }), " describes how to integrate Prisma into a Turborepo, including:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Prisma client initialization"
      }), "\n", _jsxs(_components.li, {
        children: ["Packaging the client as an ", _jsx(_components.a, {
          href: "/docs/core-concepts/internal-packages",
          children: "Internal Package"
        })]
      }), "\n", _jsx(_components.li, {
        children: "Performing migrations"
      }), "\n", _jsx(_components.li, {
        children: "Working on your applications locally"
      }), "\n", _jsx(_components.li, {
        children: "Deploying"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "example",
      children: "Example"
    }), "\n", _jsx(_components.p, {
      children: "To get started with our community-supported Prisma example, run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo@latest"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -e"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " with-prisma"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
